/* Formatting and date helpers. Dates are handled as plain YYYY-MM-DD
   strings throughout, never as timestamps, so a contractual due date reads
   the same in the territory as it does in the office. */

export const today = () => new Date().toISOString().slice(0, 10);

export const fmtMoney = (n) =>
  n || n === 0
    ? "$" + Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })
    : "";

/* Dates are stored and compared as YYYY-MM-DD. They are read as US dates,
   because that is how every one of these workbooks writes them and how the
   team says them out loud. Sliced rather than parsed, so no timezone can
   move a contractual date by a day. */
export const fmtDate = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d ?? ""));
  return m ? `${m[2]}/${m[3]}/${m[1]}` : (d ?? "");
};

export const fmtK = (n) => {
  const v = Number(n) || 0;
  if (v >= 1e6) return "$" + (v / 1e6).toFixed(1) + "M";
  if (v >= 1e3) return "$" + Math.round(v / 1e3) + "K";
  return "$" + Math.round(v);
};

/* Whole days elapsed since d, relative to today. Negative means d is ahead. */
export const daysFrom = (d, ref = today()) =>
  Math.floor((new Date(ref) - new Date(d)) / 86400000);

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x.toISOString().slice(0, 10);
};

export const initials = (name) =>
  String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const shortName = (name) => {
  const parts = String(name || "").split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  return parts[1] ? `${parts[0]} ${parts[1][0]}.` : parts[0];
};

export const truncate = (s, n) =>
  String(s || "").length > n ? String(s).slice(0, n) + "…" : String(s || "");

export const fiscalQuarter = (d = new Date()) =>
  `FY${d.getFullYear()} Q${Math.floor(d.getMonth() / 3) + 1}`;
